export type TimeSlotDTO = {
    startTimeTz: string;
    finishTimeTz: string;
}

export type PresetTimeSlotName = 'Available' | 'Unavailable' | 'Clear';

export type TimeSlot = {
    startTimeTz: string;
    finishTimeTz: string;
};

export function createTimeSlot(startTimeTz: string, finishTimeTz: string): TimeSlot {
    return {
        startTimeTz,
        finishTimeTz
    };
}

export function isTimeSlotEqual(slot1: TimeSlot, slot2: TimeSlot | null): boolean {
    if (slot2 === null) {
        return false;
    }

    return (slot1.startTimeTz === slot2.startTimeTz &&
            slot1.finishTimeTz === slot2.finishTimeTz
    );
}

export function timeSlotToDTO(slot: TimeSlot): TimeSlotDTO | null {
    if (isTimeSlotEqual(slot, PresetTimeSlots.allDayAvailable) || isTimeSlotEqual(slot, PresetTimeSlots.allDayUnavailable)) {
        return null;
    }

    return {
        startTimeTz: slot.startTimeTz,
        finishTimeTz: slot.finishTimeTz
    };
}

export const PresetTimeSlots: { [ key: string ]: TimeSlot } = {
    allDayAvailable: createTimeSlot('-', '-'),
    allDayUnavailable: createTimeSlot('-', '-'),
    cleared: createTimeSlot('-', '-')
};
